import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TRANSFORM_AFTER, TRANSFORM_BEFORE } from './salesData';
export function TransformationSection() {
  return <section id="transformacion" className="bg-charcoal py-12 sm:py-16" data-id="element-264" data-mp="2wzgr7ytf572j">
      <div className="mx-auto max-w-4xl px-5" data-id="element-265" data-mp="2ry18weimlenu">
        <div className="text-center" data-id="element-266" data-mp="2nwpfdxwms9ad">
          <SectionTag className="border-gold/50 bg-charcoal-soft text-gold-soft" data-id="element-267" data-mp="2nxr0kv7d2c5t">
            La transformación
          </SectionTag>
          <h2 className="mt-4 font-display text-[1.55rem] font-bold uppercase leading-tight text-ivory sm:text-[2.2rem]" data-id="element-268" data-mp="2j4edipibydf6">
            De publicar sin rumbo
            <span className="mt-1 block text-gold" data-id="element-269" data-mp="299e1vqgw2f7m">a tener un sistema para crecer</span>
          </h2>
        </div>

        <div className="mt-8 grid items-stretch gap-3 sm:grid-cols-[1fr_auto_1fr]" data-id="element-270" data-mp="248gijak57f4j">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35
        }} className="rounded-2xl border border-ivory/15 bg-charcoal-soft/60 p-5" data-id="element-271" data-mp="208o80sb6uywj">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-ivory/50" data-id="element-272" data-mp="5ehdiiosye8r">
              Antes
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-273" data-mp="y1k7cxija0so">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-274" data-mp="130n29p4suqmx">
                  <XIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-ivory/40" aria-hidden data-id="element-275" data-mp="12zvidbkkehch" />
                  <span className="font-sans text-[0.84rem] leading-snug text-ivory/60" data-id="element-276" data-mp="p0m2ye46nr9k">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <div className="flex items-center justify-center" aria-hidden data-id="element-277" data-mp="39q1sl5ro19xm">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold" data-id="element-278" data-mp="3dt7szws3k6w6">
              <ArrowRightIcon className="h-4 w-4 rotate-90 text-ivory sm:rotate-0" data-id="element-279" data-mp="1k9ploexsuwe4" />
            </span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: 0.08
        }} className="rounded-2xl border border-gold/40 bg-charcoal-soft p-5" data-id="element-280" data-mp="1famlb7srlech">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold" data-id="element-281" data-mp="11k99uvgnzhie">
              Después
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-282" data-mp="wmra9vojeen2">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-283" data-mp="rn4wnl4sqwdq">
                  <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-284" data-mp="mns20e7ool0l" />
                  <span className="font-sans text-[0.84rem] font-medium leading-snug text-ivory" data-id="element-285" data-mp="2lyt3t14sdunk">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}